const initializeCommunityInfiniteScroll = () => {
    const postsContainer = document.getElementById(
        'community-posts'
    );

    const paginationContainer = document.getElementById(
        'community-pagination'
    );

    const fallbackPagination = document.getElementById(
        'community-pagination-fallback'
    );

    const statusContainer = document.getElementById(
        'community-load-status'
    );

    const loadingIndicator = document.getElementById(
        'community-loading'
    );

    const errorIndicator = document.getElementById(
        'community-load-error'
    );

    const completeIndicator = document.getElementById(
        'community-load-complete'
    );

    const retryButton = document.getElementById(
        'community-load-retry'
    );

    const sentinel = document.getElementById(
        'community-scroll-sentinel'
    );

    if (
        ! postsContainer
        || ! paginationContainer
        || ! sentinel
    ) {
        return;
    }

    /*
     * Keep normal pagination available when the browser does not
     * support IntersectionObserver.
     */
    if (! ('IntersectionObserver' in window)) {
        return;
    }

    fallbackPagination?.classList.add('hidden');
    statusContainer?.classList.remove('hidden');

    let nextPageUrl =
        paginationContainer.dataset.nextPageUrl || null;

    let isLoading = false;
    let hasFinished = ! nextPageUrl;

    const hideStatusSections = () => {
        loadingIndicator?.classList.add('hidden');
        errorIndicator?.classList.add('hidden');
        completeIndicator?.classList.add('hidden');
    };

    const showLoading = () => {
        hideStatusSections();
        loadingIndicator?.classList.remove('hidden');
    };

    const showError = () => {
        hideStatusSections();
        errorIndicator?.classList.remove('hidden');
    };

    const showComplete = () => {
        hideStatusSections();
        completeIndicator?.classList.remove('hidden');
    };

    const appendPosts = (html) => {
        const template = document.createElement('template');

        template.innerHTML = html.trim();

        postsContainer.append(
            template.content.cloneNode(true)
        );
    };

    const loadNextPage = async () => {
        if (
            isLoading
            || hasFinished
            || ! nextPageUrl
        ) {
            return;
        }

        isLoading = true;
        showLoading();

        try {
            const response = await fetch(
                nextPageUrl,
                {
                    method: 'GET',

                    headers: {
                        Accept: 'application/json',

                        'X-Requested-With':
                            'XMLHttpRequest',
                    },

                    credentials: 'same-origin',
                }
            );

            if (! response.ok) {
                throw new Error(
                    `Request failed with status ${response.status}.`
                );
            }

            const data = await response.json();

            if (
                typeof data.html !== 'string'
                || typeof data.has_more_pages !== 'boolean'
            ) {
                throw new Error(
                    'The server returned an invalid response.'
                );
            }

            if (data.html.trim() !== '') {
                appendPosts(data.html);
            }

            nextPageUrl = data.next_page_url || null;

            paginationContainer.dataset.nextPageUrl =
                nextPageUrl || '';

            hasFinished =
                ! data.has_more_pages
                || ! nextPageUrl;

            if (hasFinished) {
                showComplete();
                observer.disconnect();
            } else {
                hideStatusSections();
            }
        } catch (error) {
            console.error(
                'Unable to load additional community discussions:',
                error
            );

            showError();
        } finally {
            isLoading = false;
        }
    };

    const observer = new IntersectionObserver(
        (entries) => {
            const sentinelEntry = entries[0];

            if (sentinelEntry?.isIntersecting) {
                loadNextPage();
            }
        },
        {
            /*
             * Begin loading before the member reaches the absolute
             * bottom of the page.
             */
            rootMargin: '600px 0px',
            threshold: 0,
        }
    );

    retryButton?.addEventListener(
        'click',
        () => {
            loadNextPage();
        }
    );

    if (hasFinished) {
        showComplete();
        return;
    }

    observer.observe(sentinel);
};

if (document.readyState === 'loading') {
    document.addEventListener(
        'DOMContentLoaded',
        initializeCommunityInfiniteScroll
    );
} else {
    initializeCommunityInfiniteScroll();
}